export enum TournamentActions {
  StartLoading = 'startLoading',
  ApproveRequest = 'approveRequest',
  RejectRequest = 'rejectRequest',
}

export enum TournamentGetters {
  EditModes = 'EditModes',
}

export enum TournamentMutations {
  StartLoading = 'startLoading',
  ClearHttpErrors = 'clearHttpErrors',
  HttpError = 'httpError',
  FinishLoading = 'finishLoading',
  InitTournament = 'initTournament',
  ToggleRequestEditMode = 'toggleRequestEditMode',
  UpdateRequestOrganizerComment = 'updateRequestOrganizerComment',
  ApproveRequest = 'approveRequest',
  RejectRequest = 'rejectRequest',
}

export interface StartLoading {
  tournamentId: number;
  forumThreadId: number;
}

export interface InitTournament {
  tournamentId: number;
  forumThreadId: number;
  requests: TournamentRequest[];
}

export interface UpdateRequestOrganizerComment {
  requestId: string;
  comment: string;
}

export interface EditModes {
  [key: string]: boolean;
}

export interface TournamentState {
  isLoaded: boolean;
  hasHttpError: boolean;
  tournamentId?: number;
  forumThreadId?: number;
  requests: TournamentRequest[];
  requestEditModes: EditModes;
}

export interface TournamentRequest {
  approveTime: string;
  createTime: string;
  icq: string;
  id: string;
  isApproved: boolean | null;
  organizerComment: string;
  playerComment: string;
  profileLink: string;
  skype: string;
  userId: number;
  username: string;
}
